import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  TextField,
  DialogActions,
  TablePagination,
  Typography,
  ThemeProvider,
  createTheme,
  Box,
  Chip,
  Autocomplete,
  InputAdornment,
  IconButton,
  InputBase,
  Divider,
  Popover,
  useMediaQuery,
} from "@mui/material";
import OpenInBrowser from "@mui/icons-material/OpenInBrowser";
import KeyboardDoubleArrowRightOutlined from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import {
  Add,
  Close,
  Delete,
  DeleteOutline,
  DoNotDisturbAlt,
  Edit,
  GroupAdd,
  Search,
  StopCircle,
  Warning,
} from "@mui/icons-material";
// import './publisher-list.styles.scss';
import { TransitionProps } from "@mui/material/transitions";
import apiClient from "@lift-admin/utils/apiClient";
import { debounce } from "@lift-admin/utils/debounce";
import { useDispatch, useSelector } from "react-redux";

// import DataGrid, {
//   Column,
//   // RowSelectionProps,
//   SortColumn,
//   // GridColDef
//   textEditor
// } from 'react-data-grid';
import { DataGrid, GridEditSingleSelectCell } from "@mui/x-data-grid";
// import 'react-data-grid/lib/styles.css';

import { Tooltip } from "@lift-admin/ui/tooltip";
import { Toastify } from 'lift-ui';
import { makeStyles } from "@mui/styles";
import { IconLayoutGridAdd, IconX } from "@tabler/icons-react";

// import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridApi, GridOptions } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import axios from "axios";
import { actionLog } from "../../../App";
import {
  buildDetails,
  buildSummary,
  diffFields,
  type FieldSpec,
} from "@lift-admin/utils/logChangeFormatter";

const SANDBOX_FIELD_SPECS: FieldSpec[] = [
  { key: "display_name", label: "Display Name" },
  { key: "embeded_url", label: "Embedded URL" },
  { key: "url_type", label: "URL Type" },
  { key: "description", label: "Description" },
  { key: "maintainer", label: "Maintainer" },
  { key: "contact_info", label: "Contact Info" },
];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#16306D",
    },
    secondary: {
      main: "rgba(0, 0, 0, 0)",
    },
  },
  typography: {
    fontFamily: '"Figtree", sans-serif',
  },
});
const useStyles = makeStyles({
  blockedRow: {
    backgroundColor: "#ffd8c7",
  },
});
interface ItemsProps {
  toggle: string;
  searchText: string;
  // channelsBody: { name: string; icon: string };
  // setChannelsBody: (channel: { name: string; icon: string }) => void;
  openDialog: boolean;
  setOpenDialog: any;
}

const ReportsSandbox = ({
  toggle,
  searchText,
  // channelsBody,
  // setChannelsBody,
  openDialog,
  setOpenDialog,
}: ItemsProps) => {
  const [loadData, setLoadData] = useState<boolean>(false);
  const [drawerItem, setDrawerItems] = useState<any>([]);
  const [drawerItemBackUp, setDrawerItemsBackup] = useState<any>([]);

  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);

  const [currentIdData, setCurrentIdData] = useState<any>(null);
  const [display_name, setDisplayName] = useState<string | null>();
  const [maintainer, setMaintainer] = useState<string | null>();
  const [contact_info, setContactInfo] = useState<string | null>();
  const [url_type, setURLType] = useState<string | null>();
  const [embeded_url, setEmbededURL] = useState<string | null>();
  const [description, setDescription] = useState<string | null>();
  const [searchedResults, setSearchedResults] = useState<any>([]);

  const getReports = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        "/drawer/v1/admin/drawer/structure/drawer-items-reports-sandbox"
      );

      const drawerReport = res?.data?.response?.drawerReport.sort(
        (
          a: { created_at: string | number | Date },
          b: { created_at: string | number | Date }
        ) => {
          // Assuming created_at is in ISO 8601 format (e.g., "2024-12-17T14:52:29.000Z")
          return (
            (new Date(b.created_at) as any) - (new Date(a.created_at) as any)
          );
        }
      );
      console.log(drawerReport, "drawerReport");
      if (searchText.trim().length === 0) {
        setDrawerItems(drawerReport);
        console.log(drawerReport, "drawerReport");
      } else {
        setDrawerItems(
          drawerReport.filter((item: any) => searchedResults.includes(item.id))
        );
      }

      setDrawerItemsBackup(drawerReport);
    } catch {
      Toastify("error", "Something went wrong");
    } finally {
      setLoadData(false);
    }
  };
  useEffect(() => {
    getReports();
  }, []);

  const resetState = () => {
    setDisplayName("");
    setURLType("");
    setEmbededURL("");
    setDescription("");
    setCurrentIdData(null);
    setMaintainer("");
    setContactInfo("");
  };

  const rowData = useMemo(() => drawerItem, [drawerItem]);

  const columnDefs = useMemo(
    () => [
      {
        field: "display_name",
        headerName: "Display Name",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
      },
      {
        field: "embeded_url",
        headerName: "Embedded URL",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
      },
      // {
      //   field: 'url_type',
      //   headerName: 'URL Type',
      //   width: 250,
      //   sortable: true,
      //   resizable: true,
      //   editable: true,
      //   flex: 1,
      //   cellStyle: { display: 'flex', alignItems: 'center' },
      // },
      {
        field: "description",
        headerName: "Description",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
      },
      {
        field: "owner",
        headerName: "Owner",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => params?.data?.owner?.name || "",
      },
      {
        field: "maintainer",
        headerName: "Maintainer",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => params?.data?.maintainer || "",
      },
      {
        field: "contact_info",
        headerName: "Contact Info",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => params?.data?.contact_info || "",
      },
      {
        field: "modified_by",
        headerName: "Modified By",
        width: 250,
        sortable: true,
        resizable: true,
        editable: true,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueGetter: (params: any) => params?.data?.modified_by?.name || "",
      },
      {
        field: "created_at",
        headerName: "Created At",
        width: 200,
        sortable: true,
        resizable: true,
        editable: false,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueFormatter: (params: { value: string }) => {
          if (!params.value) return "";
          const date = new Date(params.value);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        },
      },
      {
        field: "updated_at",
        headerName: "Updated At",
        width: 200,
        sortable: true,
        resizable: true,
        editable: false,
        flex: 1,
        cellStyle: { display: "flex", alignItems: "center" },
        valueFormatter: (params: { value: string }) => {
          if (!params.value) return "";
          const date = new Date(params.value);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        width: 150,
        sortable: false,
        resizable: false,
        editable: false,
        pinned: "right" as const,
        headerClass: "center-header",
        cellStyle: {
          display: "flex",
          alignItems: "center",
        },
        cellRenderer: (params: { data: any }) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                onClick={() => handleEditOpen(params?.data)}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <Edit style={{ color: "black" }} />
              </Button>
            </div>
          );
        },
      },
    ],
    []
  );

  const defaultColDef = {
    resizable: true,
    sortable: true,
    editable: false, // Can be overridden per column
  };
  // const rowData = drawerStructure; // Assuming `paginatedList` is your data array

  const onCellValueChanged = (params: { data: any }) => {
    console.log("Data after change:", params.data);
    // Handle updated data (e.g., update your state or call an API)
  };

  const handleDialogClose = () => {
    setOpenDialog((prev: any) => ({
      ...prev,
      reportSandbox: false,
    }));
    resetState();
  };

  const handleAddChannel = async () => {
    try {
      if (!display_name || display_name.length == 0) {
        Toastify("error", "Please enter correct Display name");
        return;
      }

      // if (!url_type || url_type.length == 0) {
      //   Toastify('error', 'Please enter correct URL Type');
      //   return;
      // }

      if (!embeded_url || embeded_url.length == 0) {
        Toastify("error", "Please enter correct Embeded Url");
        return;
      }

      if (!description || description.length == 0) {
        Toastify("error", "Please enter correct description");
        return;
      }

      const user = JSON.parse(localStorage.getItem("user") || "");
      const payload = {
        display_name,
        embeded_url,
        url_type: "Sandbox",
        description,
        owner: user.id,
        modified_by: user.id,
        maintainer,
        contact_info,
      };
      const res = await apiClient.post(
        "/drawer/v1/admin/drawer/structure/drawer-item-report",
        {
          display_name,
          embeded_url,
          url_type: "Sandbox",
          description,
          owner: user.id,
          modified_by: user.id,
          maintainer,
          contact_info,
        }
      );

      getReports();
      resetState();
      Toastify("success", "Report added successfully");
      console.log(res, "res");
      const createdSandbox = {
        display_name: payload.display_name,
        embeded_url: payload.embeded_url,
        url_type: payload.url_type,
        description: payload.description,
        maintainer: payload.maintainer,
        contact_info: payload.contact_info,
      };
      const desc = {
        message: buildSummary("Report sandbox", payload?.display_name, "created"),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "create_report_sandbox",
        reportId: res.data?.id ?? null,
        reportName: payload?.display_name,
        details: buildDetails(createdSandbox, SANDBOX_FIELD_SPECS, {
          skipEmpty: true,
        }),
      };

      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
    } catch (err: any) {
      console.log(err, "error");
      if (err.response?.data?.message === "Validation failed") {
        Toastify("error", err.response.data.errors[0].message);
      } else {
        Toastify("error", err.response?.data?.message || "Something went wrong");
      }
      const errorDesc = {
        message: `Failed to create report sandbox "${display_name || ""}"`,
        status: err.response?.status,
        method: "POST",
        url: "/drawer/v1/admin/drawer/structure/drawer-item-report",
        category: "drawer",
        action: "create_report_sandbox",
        reportName: display_name,
        error:
          err.response?.data?.errors?.[0]?.message ||
          err.response?.data?.message ||
          err.message,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
    }
  };

  const handleDelete = async (data: any) => {
    try {
      if (!data?.id || isNaN(data?.id)) {
        Toastify("error", "Invalid Report ID. Please select correct report");
        return;
      }
      const res = await apiClient.delete(
        `/drawer/v1/admin/drawer/structure/drawer-report/${data?.id}`
      );

      getReports();
      setOpenDeleteDialog(false);
      Toastify("success", "Item Deleted successfully");
      const desc = {
        message: buildSummary("Report sandbox", data?.display_name, "deleted"),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "delete_report_sandbox",
        reportId: data?.id,
        reportName: data?.display_name,
        details: buildDetails(
          {
            display_name: data?.display_name,
            embeded_url: data?.embeded_url,
            url_type: data?.url_type,
            description: data?.description,
            maintainer: data?.maintainer,
            contact_info: data?.contact_info,
          },
          SANDBOX_FIELD_SPECS,
          { skipEmpty: true }
        ),
      };
      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
      console.log(res, "res");
    } catch (err: any) {
      Toastify("error", "Report Sandbox not deleted");
      const errorDesc = {
        message: `Failed to delete report sandbox "${data?.display_name || ""}"`,
        status: err.response?.status,
        method: "DELETE",
        url: `/drawer/v1/admin/drawer/structure/drawer-report/${data?.id}`,
        category: "drawer",
        action: "delete_report_sandbox",
        reportId: data?.id,
        reportName: data?.display_name,
        error: err.response?.data?.message || err.message,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
    }
  };

  const handleEdit = async () => {
    if (!currentIdData?.id || isNaN(currentIdData?.id)) {
      Toastify("error", "Invalid report ID. Please select correct report");
      return;
    }

    if (!display_name || display_name.length == 0) {
      Toastify("error", "Please enter correct Display name");
      return;
    }

    // if (!url_type || url_type.length == 0) {
    //   Toastify('error', 'Please enter correct URL Type');
    //   return;
    // }

    if (!embeded_url || embeded_url.length == 0) {
      Toastify("error", "Please enter correct Embeded Url");
      return;
    }

    if (!description || description.length == 0) {
      Toastify("error", "Please enter correct description");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user") || "");
    try {
      const payload = {
        display_name,
        embeded_url,
        url_type: "Sandbox",
        description,
        modified_by: user.id,
        maintainer,
        contact_info,
      };
      const res = await apiClient.put(
        `/drawer/v1/admin/drawer/structure/drawer-report/${currentIdData?.id}`,
        {
          display_name,
          embeded_url,
          url_type: "Sandbox",
          description,
          modified_by: user.id,
          maintainer,
          contact_info,
        }
      );

      Toastify("success", "Item updated successfully");
      const previousSandbox = {
        display_name: currentIdData?.display_name,
        embeded_url: currentIdData?.embeded_url,
        url_type: currentIdData?.url_type,
        description: currentIdData?.description,
        maintainer: currentIdData?.maintainer,
        contact_info: currentIdData?.contact_info,
      };
      const nextSandbox = {
        display_name: payload.display_name,
        embeded_url: payload.embeded_url,
        url_type: payload.url_type,
        description: payload.description,
        maintainer: payload.maintainer,
        contact_info: payload.contact_info,
      };
      getReports();
      handleEditDialogClose();
      const changes = diffFields(
        previousSandbox,
        nextSandbox,
        SANDBOX_FIELD_SPECS
      );
      const desc = {
        message: buildSummary(
          "Report sandbox",
          payload.display_name || currentIdData?.display_name,
          "updated",
          changes.length
        ),
        status: res.status,
        method: res.config.method,
        url: res.config.url,
        category: "drawer",
        action: "update_report_sandbox",
        reportId: currentIdData?.id,
        reportName: payload.display_name || currentIdData?.display_name,
        changes,
      };
      await actionLog?.actionLogTrack(JSON.stringify(desc), false);
    } catch (err: any) {
      console.log(err, "error");
      if (err.response?.data?.message === "Validation failed") {
        Toastify("error", err.response.data.errors[0].message);
      } else {
        Toastify("error", err.response?.data?.message || "Something went wrong");
      }
      const errorDesc = {
        message: `Failed to update report sandbox "${display_name || currentIdData?.display_name || ""}"`,
        status: err.response?.status,
        method: "PUT",
        url: `/drawer/v1/admin/drawer/structure/drawer-report/${currentIdData?.id}`,
        category: "drawer",
        action: "update_report_sandbox",
        reportId: currentIdData?.id,
        reportName: display_name || currentIdData?.display_name,
        error:
          err.response?.data?.errors?.[0]?.message ||
          err.response?.data?.message ||
          err.message,
      };
      await actionLog?.actionLogTrack(JSON.stringify(errorDesc), true);
    }
  };

  const handleSubmit = () => {
    // setChannelsBody({ name, icon });
    setOpenDialog(false);
    handleAddChannel();
  };

  const handleEditOpen = (data: any) => {
    setCurrentIdData(data);
    setDisplayName(data?.display_name);
    setEmbededURL(data?.embeded_url);
    setDescription(data?.description);
    setURLType(data?.url_type);
    setMaintainer(data?.maintainer);
    setContactInfo(data?.contact_info);
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {
    // setOpenDialog(false);
    setDisplayName("");
    setEmbededURL("");
    setDescription("");
    setURLType("");
    setCurrentIdData(null);
    setOpenEditDialog(false);
    setMaintainer("");
    setContactInfo("");
  };

  const allUrlTypes = ["Normal", "Fiscal", "FinTech"];

  const searchResults = (query: any) => {
    const filteredUsers = [...drawerItemBackUp];
    let results = [];
    for (let i = 0; i < filteredUsers.length; i++) {
      if (
        filteredUsers[i]["display_name"]
          ?.toLowerCase()
          .includes(query.toLowerCase()) ||
        filteredUsers[i]["embeded_url"]
          ?.toLowerCase()
          .includes(query.toLowerCase()) ||
        filteredUsers[i]["url_type"]
          ?.toLowerCase()
          .includes(query.toLowerCase())
      )
        results.push(filteredUsers[i]);
    }
    setSearchedResults(results.map((item: any) => item.id));
    setDrawerItems(results);
  };

  useEffect(() => {
    searchResults(searchText);
  }, [searchText]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Paper className="table-paper" style={{ paddingLeft: 0 }}>
          <div
            className="ag-theme-alpine"
            style={{ height: "100%", width: "100%" }}
          >
            <AgGridReact
              columnDefs={columnDefs.map((colDef) => ({
                ...colDef,
                editable: false,
                cellRendererFramework: (params: any) => {
                  if (colDef.field === "delete") {
                    return (
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setOpenDeleteDialog(true)}
                      >
                        Delete
                      </Button>
                    );
                  }
                  return params.value;
                },
              }))}
              rowData={rowData}
              defaultColDef={defaultColDef}
              rowHeight={80}
              onCellValueChanged={onCellValueChanged}
              pagination={true}
              paginationPageSize={20}
              suppressPaginationPanel={false}
            />
          </div>
        </Paper>
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                handleDelete(currentIdData);
              }}
              color="primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openDialog} onClose={handleDialogClose}>
          <DialogTitle>Add New Report</DialogTitle>
          <DialogContent style={{ padding: "10px" }}>
            <TextField
              label="Display Name"
              value={display_name}
              onChange={(e) => {
                setDisplayName(e.target.value);
              }}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Embeded URL"
              value={embeded_url}
              onChange={(e) => setEmbededURL(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            {/* <Autocomplete
              value={url_type}
              options={allUrlTypes}
              getOptionLabel={(option) => option}
              onChange={(event, value) => setURLType(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="URL Type"
                  fullWidth
                  style={{ marginBottom: '16px' }}
                />
              )}
            /> */}
            <TextField
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Maintainer"
              value={maintainer}
              onChange={(e) => setMaintainer(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Contact Info"
              value={contact_info}
              onChange={(e) => setContactInfo(e.target.value)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openEditDialog} onClose={handleEditDialogClose}>
          <DialogTitle>Edit Item</DialogTitle>
          <DialogContent style={{ padding: "10px" }}>
            <TextField
              label="Display Name"
              value={display_name}
              onChange={(e) => setDisplayName(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Embeded URL"
              value={embeded_url}
              onChange={(e) => setEmbededURL(e.target.value)}
              style={{ marginBottom: "16px" }}
              fullWidth
            />
            {/* <Autocomplete
              value={url_type}
              options={allUrlTypes}
              getOptionLabel={(option) => option}
              onChange={(event, value) => setURLType(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="URL Type"
                  fullWidth
                  style={{ marginBottom: '16px' }}
                />
              )}
            /> */}
            <TextField
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Maintainer"
              value={maintainer}
              onChange={(e) => setMaintainer(e.target.value)}
              fullWidth
              style={{ marginBottom: "16px" }}
            />
            <TextField
              label="Contact Info"
              value={contact_info}
              onChange={(e) => setContactInfo(e.target.value)}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleEditDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleEdit} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ReportsSandbox;
